module.exports = __webpack_public_path__ + "img/logo.cfc3b1ee.png";